import * as eventTypes from '../../../../js/document/event-types'
import { accommodationFacilitiesMapper } from '../mappers/accommodation-facilities/accommodation-facilities-mapper'
import pusher from '../pusher'

export function listenCollapseEvents (event, track) {
  event.on(eventTypes.collapseEvents.OPEN, (data) => {
    const mappedData = accommodationFacilitiesMapper(data, eventTypes.collapseEvents.OPEN, track)
    pusher.pushDataObject(mappedData)
  })

  event.on(eventTypes.collapseEvents.CLOSE, (data) => {
    const mappedData = accommodationFacilitiesMapper(data, eventTypes.collapseEvents.CLOSE, track)
    pusher.pushDataObject(mappedData)
  })
}
